require('particles.js');
declare let particlesJS: any;

export class BackgroundDrawer {

    constructor(private selector: string) {
    }

    draw() {
        particlesJS(this.selector, {
            'particles': {
                'number': {
                    'value': 15,
                    'density': {
                        'enable': true,
                        'value_area': 2000
                    }
                },
                'color': {
                    'value': ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#FB706D', '#FB706D', '#F6FF7A']
                },
                'shape': {
                    'type': 'circle',
                    'stroke': {
                        'width': 0,
                        'color': '#000000'
                    },
                    'polygon': {
                        'nb_sides': 5
                    },
                    'image': {
                        'src': 'img/github.svg',
                        'width': 100,
                        'height': 100
                    }
                },
                'opacity': {
                    'value': 1,
                    'random': true,
                    'anim': {
                        'enable': true,
                        'speed': 1,
                        'opacity_min': .7,
                        'sync': false
                    }
                },
                'size': {
                    'value': 15,
                    'random': true,
                    'anim': {
                        'enable': false,
                        'speed': 4,
                        'size_min': 1,
                        'sync': false
                    }
                },
                'line_linked': {
                    'enable': false,
                    'distance': 150,
                    'color': '#ffffff',
                    'opacity': 0.4,
                    'width': 1
                },
                'move': {
                    'enable': true,
                    'speed': 2,
                    'direction': 'top',
                    'random': true,
                    'straight': false,
                    'out_mode': 'out',
                    'bounce': false,
                    'attract': {
                        'enable': false,
                        'rotateX': 600,
                        'rotateY': 600
                    }
                }
            },
            'interactivity': {
                'detect_on': 'canvas',
                'events': {
                    'onhover': {
                        'enable': false,
                        'mode': 'bubble'
                    },
                    'onclick': {
                        'enable': false,
                        'mode': 'repulse'
                    },
                    'resize': true
                },
                'modes': {
                    'grab': {
                        'distance': 400,
                        'line_linked': {
                            'opacity': 1
                        }
                    },
                    'bubble': {
                        'distance': 250,
                        'size': 0,
                        'duration': 2,
                        'opacity': 0,
                        'speed': 3
                    },
                    'repulse': {
                        'distance': 400,
                        'duration': 0.4
                    },
                    'push': {
                        'particles_nb': 4
                    },
                    'remove': {
                        'particles_nb': 2
                    }
                }
            },
            'retina_detect': true
        });
    }
}
